import React, { useState } from 'react';
import { css, Theme, useTheme } from "@emotion/react";
import Tippy from "@tippy.js/react";

import OptionCard from "pages/Components/CartAndCheckout/components/OptionCard";
import { ReactComponent as InvoiceIcon } from "images/icons/pay-invoice.svg";
import SignIn from "pages/Components/auth/SignIn";
import SignUp from "pages/Components/auth/SignUp";
import { useAppState } from "core/contexts/AppContext";
import { defaultTippyProps, defaultTippyStyle } from "core/includes/tippy";

const CHECKOUT_OPTIONS = [
    {
        label: 'Returning Customer',
        isGuest: false,
        icon: InvoiceIcon,
    },
    {
        label: 'Continue as a guest',
        isGuest: true,
        icon: InvoiceIcon,
    }
];

type Props = {
    onSelect: (isGuest: boolean) => void,
}

const Authentication = ({ onSelect }: Props) => {
    const theme: Theme = useTheme();

    const [showSignUp, setShowSignUp] = useState(false);
    const [appState] = useAppState();

    const hasOnlineEvent = appState.cart?.products?.some((product: CartProduct) => product.isDigital) || false

    const onAuthOption = (isSignUp: boolean = false) => {
        setShowSignUp(isSignUp);
    }

    const optionsContainerStyle = css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 30px;

        > div:first-of-type {
            ${theme.breakpoints.up('3xl')} {
                margin-right: 60px;
            }

            ${theme.breakpoints.up('xxl')} {
                margin-right: 63px;
            }

            ${theme.breakpoints.up('xl')} {
                margin-right: 34px;
            }

            ${theme.breakpoints.between('md', 'lg')} {
                margin-right: 47px;
            }

            ${theme.breakpoints.up('sm')} {
                margin-right: 44px;
            }

            ${theme.breakpoints.down('xs')} {
                margin-bottom: 17px;
            }
        }

        ${theme.breakpoints.down('md')} {
            margin-top: 9px;
            margin-bottom: 20px;
        }


        ${theme.breakpoints.down('sm')} {
            margin-top: 8px;
            margin-bottom: 12px;
        }

        ${theme.breakpoints.down('xs')} {
            flex-direction: column;
            margin-top: 13px;
            margin-bottom: 11px;
        }
    `;

    const guestOptionCard = css`
        ${hasOnlineEvent && css`
            pointer-events: none;
            opacity: 0.6;
        `}
    `;

    return (
        <div css={optionsContainerStyle}>
            {CHECKOUT_OPTIONS.map((option, index) => (
                !option.isGuest ? (
                    showSignUp ?
                        <SignUp onLogin={() => onAuthOption(false)} /> :
                        <SignIn onSignUp={onAuthOption} />
                ) : (
                    <React.Fragment key={index}>
                        <Tippy
                            content={"Online events are linked to an account, so you need to create one or log in."}
                            hideOnClick={false}
                            enabled={hasOnlineEvent}
                            {...defaultTippyProps}
                            css={defaultTippyStyle}
                        >
                            <div>
                                <OptionCard
                                    optionLabel={option.label}
                                    Icon={option.icon}
                                    onSelection={() => onSelect(true)}
                                    isSelected={false}
                                    key={option.label}
                                    hasCircle={false}
                                    css={guestOptionCard}
                                />
                            </div>
                        </Tippy>
                    </React.Fragment>
                )
            ))}
        </div>
    );
}

export default Authentication;